<template>
  <md-toolbar md-elevation="2" class="md-transparent">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <!-- <md-list-item href="#/notifications" class="dropdown">
              <drop-down>
                <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="material-icons">notifications</i>
                  <span class="notification">5</span>
                  <p class="hidden-lg hidden-md">Notifications</p>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li><a href="#">Mike John responded to your email</a></li>
                  <li><a href="#">You have 5 new tasks</a></li>
                  <li><a href="#">You're now friend with Andrew</a></li>
                  <li><a href="#">Another Notification</a></li>
                  <li><a href="#">Another One</a></li>
                </ul>
              </drop-down>
            </md-list-item> -->

            <li class="md-list-item">
              <a
                href="#/notifications"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span class="notification" v-if="unreadCount > 0">{{ unreadCount }}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                  </drop-down>
                </div>
              </a>
            </li>

          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "@/fb";

export default {
  data() {
    return {
      unreadCount: 0,
      unsubscribe: null,
    };
  },
  computed: {
    delegationId() {
      // Obtenemos el ID de la delegación del store global
      return this.$delegateStore?.state?.delegateData?.delegation?.id || null;
    },
  },
  watch: {
    // Si el ID de la delegación cambia (ej. al cargar el perfil), reiniciamos el listener
    delegationId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.initNotificationListener(newId);
        } else if (this.unsubscribe) {
          this.unsubscribe();
          this.unreadCount = 0;
        }
      },
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    initNotificationListener(recipientId) {
      if (this.unsubscribe) this.unsubscribe();

      // Consulta en tiempo real para notificaciones no leídas del usuario
      const q = query(
        collection(db, "notifications"),
        where("recipientId", "==", recipientId),
        where("read", "==", false)
      );

      this.unsubscribe = onSnapshot(q, (snapshot) => {
        this.unreadCount = snapshot.size;
      });
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
};
</script>

<style lang="css"></style>
